module.exports = __webpack_public_path__ + "static/media/facebook-banner.f56eca07.png";